/**
 * What the order ticket tells the standard orderbook: which outcome it is on,
 * whether it is buying or selling, and how many shares are in its Shares box.
 *
 * Click to trade on the book places the ticket's order — its side, its outcome,
 * its size — at the clicked row's price, and shows the book of the ticket's
 * outcome, so the two panels share these three values. The ticket **owns** them — its own state, reset and carried across a roll by its
 * own rules — and publishes them here; the book only reads. One writer: the
 * ticket in its own column (`linkBook`), never the sheet below 1120px, where
 * the book is read-only.
 *
 * **A store of its own and not a field on `uiStore`.** `<TradeRoute>`
 * subscribes `uiStore` for the pro flag, and the size changes on every
 * keystroke — on `uiStore` it would re-render the market page per character
 * (invariant 2).
 *
 * `publishTicketLink` notifies only on a change, because the ticket's effect
 * re-runs whenever any value is re-derived and most of those are no-ops.
 */

import type { Outcome } from '@/lib/decimal'
import { ExternalStore } from './store'

export interface TicketLink {
  outcome: Outcome
  /** The ticket's Buy/Sell — the side a click on any row places. */
  side: 'BUY' | 'SELL'
  /** The Shares box as micro-shares; `0n` when it is empty or unreadable. */
  sizeShares: bigint
}

export const ticketLinkStore = new ExternalStore<TicketLink>({
  outcome: 'UP',
  side: 'BUY',
  sizeShares: 0n,
})

export function publishTicketLink(next: TicketLink): void {
  const now = ticketLinkStore.state
  if (now.outcome === next.outcome && now.side === next.side && now.sizeShares === next.sizeShares) return
  ticketLinkStore.set({ outcome: next.outcome, side: next.side, sizeShares: next.sizeShares })
  ticketLinkStore.notify()
}
